import { ADMIN_ROLE, ARTIST_ROLE, THEATER_ADMIN_ROLE } from '../constants';

export default [
  { value: ADMIN_ROLE, label: 'Administrador' },
  { value: THEATER_ADMIN_ROLE, label: 'Administrador de teatro' },
  { value: ARTIST_ROLE, label: 'Artista' },
  // { value: USER_ROLE, label: 'Normal' },
];



// WEBPACK FOOTER //
// ./src/utils/RoleOptions.js